// eCompliance: page text and the list of countries. Generated file.
const config = {
  "slug": "ecompliance",
  "name": "eCompliance",
  "menu": {
    "show": false,
    "label": "eCompliance",
    "desc": "Pre-built tax controls with drill-down to the transaction"
  },
  "meta": {
    "title": "eCompliance: Pre-Built Tax Controls for SAP | Taxera",
    "description": "eCompliance is a pre-built, event-driven tax control framework. Connect it to your systems and see your tax compliance picture, down to the transaction."
  },
  "hero": {
    "h1": "Tax controls that are already built.",
    "h1Accent": "Connect, and see your results.",
    "text": "eCompliance is a pre-built, event-driven tax control framework. The controls, KPIs and notifications are already defined, so once Taxera is connected to your systems you see your tax compliance picture within the hour, from group level down to a single transaction.",
    "secondaryCta": "See where it is useful",
    "externalCta": {
      "label": "Explore eCompliance at taxera.app",
      "url": "https://taxera.app"
    }
  },
  "countriesSection": {
    "heading": "eCompliance",
    "intro": "eCompliance works across countries.",
    "trackerPath": "/tracker"
  },
  "what": {
    "heading": "What is eCompliance, in plain words?",
    "paragraphs": [
      "Tax problems usually start in everyday business processes: a wrong tax code on a purchase, missing master data, a delivery booked in the wrong period. In most companies, nobody finds out until the return is prepared or the auditor asks.",
      "eCompliance checks transactions as they happen, across production, procurement, logistics, finance and master data. When a control finds something, it raises a notification and a workflow, so that someone is assigned to fix it and close it."
    ],
    "explainer": {
      "heading": "What makes it different",
      "items": [
        {
          "icon": "ListChecks",
          "title": "Pre-built",
          "text": "The controls and KPIs are defined before you start, so there is no long build project. You connect your systems and see results."
        },
        {
          "icon": "Radio",
          "title": "Event-driven",
          "text": "Controls run as business events occur, with notifications and workflow to assign and close each finding."
        },
        {
          "icon": "Search",
          "title": "Drill-down to the transaction",
          "text": "Start with the group-level picture and go down, step by step, to the single transaction behind a finding."
        }
      ]
    }
  },
  "apps": {
    "heading": "Where it is useful",
    "intro": "The same framework supports several jobs, from everyday control to one-off checks.",
    "items": [
      {
        "icon": "ShieldCheck",
        "title": "Ongoing finance and logistics control",
        "text": "Keep watch on the processes where tax errors start, every day, not once a year."
      },
      {
        "icon": "FileCheck2",
        "title": "e-Invoicing readiness",
        "text": "Find the master data and process gaps before a mandate goes live, not after your first invoices are rejected."
      },
      {
        "icon": "FileSpreadsheet",
        "title": "SAF-T readiness",
        "text": "Check that the data behind your audit files is complete and consistent before you have to submit them."
      },
      {
        "icon": "RefreshCw",
        "title": "SAP migration assurance",
        "text": "Compare the tax picture before and after an S/4HANA migration, to show that nothing broke on the way."
      },
      {
        "icon": "Search",
        "title": "On-demand health checks",
        "text": "Get a clear view of tax risk before an audit, an acquisition or any other event that needs one."
      }
    ]
  },
  "steps": {
    "heading": "How it works",
    "intro": "From connection to a first view of your tax risk, in four steps.",
    "items": [
      {
        "icon": "PlugZap",
        "title": "Connect your systems",
        "text": "Taxera connects to your systems. The controls are already built."
      },
      {
        "icon": "Radio",
        "title": "Controls run",
        "text": "The controls check transactions and master data as business events occur."
      },
      {
        "icon": "BellRing",
        "title": "Findings are raised",
        "text": "Notifications and workflow assign each finding to the right person."
      },
      {
        "icon": "CheckCircle2",
        "title": "Drill down and close",
        "text": "Go from the group view to the transaction, fix the cause and close the finding."
      }
    ]
  },
  "benefits": {
    "heading": "What changes for your team",
    "items": [
      {
        "icon": "Clock",
        "title": "Results fast",
        "text": "With the controls and KPIs built in advance, the first view of your tax compliance picture does not wait for a project."
      },
      {
        "icon": "AlertTriangle",
        "title": "Problems found early",
        "text": "Issues are found while they are still small, close to the transaction that caused them."
      },
      {
        "icon": "Users",
        "title": "The right person acts",
        "text": "Workflow gives each finding an owner, so it is not left in a report."
      },
      {
        "icon": "ListChecks",
        "title": "A clear trail",
        "text": "Every finding can be traced back to the transaction and shows who closed it."
      }
    ]
  },
  "faq": {
    "heading": "eCompliance, questions answered",
    "items": [
      {
        "q": "What is eCompliance?",
        "a": "eCompliance is Taxera's pre-built, event-driven tax control framework. It checks transactions and master data across production, procurement, logistics and finance, raises notifications when something is wrong, and lets you drill down from the group view to a single transaction."
      },
      {
        "q": "Who is it for?",
        "a": "Finance and tax leaders, and the business users who run tax, finance, production, procurement and logistics processes."
      },
      {
        "q": "How quickly do we see results?",
        "a": "The controls, KPIs and notifications are already defined, so you do not need a long build project. Once Taxera is connected to your systems, the first results are available within the hour."
      },
      {
        "q": "How is eCompliance different from reconciliations?",
        "a": "Reconciliations compare figures between sources, such as a VAT return and the ledgers. eCompliance checks transactions and master data against tax rules as they happen, to find the cause of problems earlier. They work well together."
      },
      {
        "q": "Can it help us prepare for e-Invoicing or SAF-T?",
        "a": "Yes. It can show where master data and processes are not ready before an e-Invoicing mandate goes live or a SAF-T file is due."
      },
      {
        "q": "Where can I find out more?",
        "a": "The eCompliance site at taxera.app has the full product story, including the group-to-transaction drill-down. You can also book a demo with us."
      }
    ]
  },
  "related": [
    {
      "to": "https://taxera.app",
      "label": "eCompliance at taxera.app",
      "note": "The full product site"
    },
    {
      "to": "/solutions/tax-finance-operations",
      "label": "Tax & Finance Operations",
      "note": "Reconciliations and month-end checks"
    },
    {
      "to": "/solutions/e-invoicing",
      "label": "e-Invoicing",
      "note": "Check readiness before a mandate"
    },
    {
      "to": "/solutions/saf-t",
      "label": "SAF-T",
      "note": "Check readiness before you submit"
    }
  ],
  "cta": {
    "heading": "See your tax compliance picture on your own systems",
    "text": "Book a short demo, or explore the full eCompliance site."
  },
  "country": {
    "eyebrow": "eCompliance {name}",
    "headingShort": "eCompliance in {name}: {short}",
    "headingPlain": "eCompliance in {name}",
    "mandateLabel": "The obligation",
    "whoLabel": "Who is affected",
    "howLabel": "How it works",
    "datesHeading": "Key dates for {name}",
    "leftHeading": "What is checked",
    "rightHeading": "What your systems have to deliver",
    "flowHeading": "The process, step by step",
    "linkedHeading": "Linked obligations in {name}",
    "faqHeading": "Questions, answered",
    "moreHeading": "More guides",
    "allLabel": "All countries",
    "otherLabel": "{name}",
    "downloadTitle": "Keep this guide",
    "downloadText": "Download the {name} guide as a PDF.",
    "printTitle": "Guide: {name}",
    "trackerPath": "/tracker",
    "faqs": [
      {
        "q": "What is the obligation in {name}?",
        "a": [
          "mandateName",
          "summary"
        ]
      },
      {
        "q": "Who is affected in {name}?",
        "a": [
          "inScope"
        ]
      },
      {
        "q": "What are the key dates in {name}?",
        "a": [
          "keyDates"
        ]
      },
      {
        "q": "How does it work in {name}?",
        "a": [
          "process"
        ]
      },
      {
        "q": "What is checked in {name}?",
        "a": [
          "businessProcess"
        ]
      },
      {
        "q": "Where are the official rules for {name}?",
        "a": [
          "officialSources"
        ]
      }
    ]
  },
  "countries": []
};
export default config;
